import React from 'react';

/**
 * Animated loading skeleton for the menu.
 */
const LoadingSkeleton = () => (
  <div className="fm-loading">
    <div className="fm-loading__spinner" />
    <p className="fm-loading__text">Loading menu…</p>
  </div>
);

/**
 * Error state with retry button.
 */
const ErrorState = ({ message, onRetry }) => (
  <div className="fm-error">
    <div className="fm-error__icon">⚠️</div>
    <h3 className="fm-error__title">Menu Unavailable</h3>
    <p className="fm-error__message">{message}</p>
    {onRetry && (
      <button className="fm-error__retry" onClick={onRetry}>
        Try Again
      </button>
    )}
  </div>
);

export { LoadingSkeleton, ErrorState };
